
        import { createApi } from '@reduxjs/toolkit/query/react';
        import { createBaseQuery } from 'src/datahandling/redux/api/apiUtils';

        // Initialize an empty API service that we'll inject endpoints into later as needed
        export const accessApi = createApi({
        reducerPath: 'accessAutoGeneratedApi',
        baseQuery: createBaseQuery("ACCESS_API"),
        
        endpoints: () => ({}),
        });

        export type accessApiType = typeof accessApi;
        export default accessApi;
    